<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter"><em>Contents</em></h1>
<p class="para3"><a class="hlink" href="#/OEBPS/list.htm"><em>List of Figures</em></a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/int.htm"><em>Introduction</em></a></p>
<p class="extract"><a class="hlink" href="#/OEBPS/c01.htm">I	Do Spells Work?</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c02.htm">II	Why and How</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c03.htm">III	The Ethics of Spell-Working</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c04.htm">IV	The Boomerang Effect</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c05.htm">V	Psychic Self-Defence</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c06.htm">VI	Setting About It</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c07.htm">VII	Sex Magic</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c08.htm">VIII	Spell-Working and the Cabala</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c09.htm">IX	Talismans</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c10.htm">X	Coming Unstuck</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c11.htm">XI	Spells of the Ancient World</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c12.htm">XII	Spells of the Middle Ages and Later</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c13.htm">XIII	Spells from Other Lands</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c14.htm">XIV	Spells of the People</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c15.htm">XV	Healing Spells</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c16.htm">XVI	Love Spells</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c17.htm">XVII	Spells to Solve Problems</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c18.htm">XVIII	Weather Spells</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c19.htm">XIX	Binding Spells</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c20.htm">XX	Odd Ones Out</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c21.htm">XXI	Tailpiece</a></p>
<p class="extract"><a class="hlink" href="#/OEBPS/ap1.htm"><em>Appendix 1: Planetary Hours</em></a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/ap2.htm"><em>Appendix 2: Planetary Squares</em></a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/ap3.htm"><em>Appendix 3: Magical Alphabets</em></a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/ap4.htm"><em>Appendix 4: Some Suppliers</em></a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/glo.htm"><em>Glossary</em></a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/bib.htm"><em>Bibliography</em></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3017c252